import MainLayout from '../layouts/main';
import Webinar from './webinar';

function WebinarPage() {
  return (
    <MainLayout loginRequired={false} studentRequired={false} title={WEBINAR_PAGE_TITLE}>
      <Webinar />
    </MainLayout>
  );
}

export const WEBINAR_PAGE_TITLE = 'وبینار 1406';

export default WebinarPage;
